import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import { toastError } from "../../common/Toast";

function LookupReceiptSaleModal() {
  let navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const paramObject = useParams();
  const [value, setValue] = useState("");
  const [receiptData, setReceiptData] = useState([]);

  const handleLookupReceiptClick = () => {

    if(value === ""){
      toastError("Please Input Sale ID")
      return;
    }

    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/lookupreceipt?saleid=${value}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setReceiptData(res.data.ResponseData);
          navigate(`/sales-receipt/${value}`);
        } else {
          console.log(res.data.ResponseData); // or display an error message
        }
      })
      .catch((error) => console.error(error));
  };


  return (
    <>
      <div
        className="modal fade"
        id="LookupReceiptSaleModal"
        tabIndex={-1}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Lookup Receipt</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <input
                    type="number"
                    className="form-control "
                    placeholder="Sale Id"
                    onChange={(event) => setValue(event.target.value)}
                  ></input>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                // type="button"
                // to="/receiving-receipt"
                className="btn btn-primary btn-md me-1 text-align-center" //form-control
                data-bs-dismiss="modal"
                onClick={() => handleLookupReceiptClick(value)}
              >
                Lookup Receipt
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LookupReceiptSaleModal;
